const $ = window.jQuery

$(() => {
  const burger = $('.header-burger')
  const html = $('html')

  window.openMobileMenu = () => {
    const mobileMenu = $('.mobilemenu')
    const isActive = mobileMenu.hasClass('mobilemenu--active')

    if (isActive) {
      burger.removeClass('header-burger--active')
      html.removeClass('mobilemenu--isopen')
    } else {
      burger.addClass('header-burger--active')
      html.addClass('mobilemenu--isopen')
    }

    mobileMenu.toggleClass('mobilemenu--active')

    return false
  }

  burger.click(window.openMobileMenu)
})
